(ns core.db.entity-api
  (:refer-clojure :exclude [find])
  (:require #?@(:clj  [[core.db.entity-api-datomic :as impl]]
                :cljs [[core.db.entity-api-mem :as impl]])))


(def ^{:arglists '([db entity-id])} entity
  "Return an entity object for entity with `entity-id` from given `db`. The
  returned entity is a map-like object that allows accessing entity attributes
  and traverse entity graph. On .clj this is identical to `datomic.api/entity`,
  of .cljs this behaves identically but uses the in-memory DB as data source."
  impl/entity)


(def ^{:arglists '([value])} entity?
  "Return truthy if `value` is an entity."
  impl/entity?)


(defn query
  "Run query in the provided DB. The `match` is a map of
  attributes and the expected values. For example, this query would return
  all forms that are child of given application:

  (query db {:entity/parent application-id
             :entity/type   :entity.type/form})

  Returns a seq of matching entities, each entity as returned by the `entity`
  function above. That is, they can be used to traverse the entity graph.

  If `match` is `nil` or the query does not match any entities, returns `nil`."
  [db match]
  (cond
    (nil? match)
    nil

    (map? match)
    (impl/query db match)

    (integer? match)
    (throw (ex-info "core.db.entity-api/query with integer `match`, use core.db.entity-api/find instead" {:match match}))

    :else
    (throw (ex-info "core.db.entity-api/query with unknown `match`" {:match match}))))


(defn find
  "Run query in the provided DB as with `core.db.entity-api/query`,
   but return single entity. If the query does not match eny entities, returns `nil`.
   If query matches multiple entities, returns one of the matched entities.
   If the `match` is integer, behaves like `core.db.entity-api/entity`."
  [db match]
  (cond
    (nil? match)
    nil

    (integer? match)
    (entity db match)

    (map? match)
    (impl/find db match)

    :else
    (throw (ex-info "core.db.entity-api/find with unknown `match`" {:match match}))))

#?(:cljs
   (defn get-id [e attr]
     (impl/get-id e attr)))
